module.exports = __webpack_public_path__ + "img/Qualification_7.d9e20a04.jpg";